module.exports = __webpack_public_path__ + "static/media/hp_logo_6.922b3b9d.png";